const url = process.env.REACT_APP_URL

console.log(process.env.REACT_APP_ENV)
console.log(process.env.REACT_APP_URL)

export default url
